import styled, { css } from 'styled-components'
import { Breakpoints } from './globalStyle'
import { themeObject } from './theme'

export const media = (props: string, width: string) => `
	@media (min-width: ${width}) {
		${props}
	};
`
export const mediaOnly = (props: string, minWidth: string, maxWidth: string) => `
	@media (min-width: ${minWidth}) and (max-width: ${maxWidth}){
		${props}
	};
`
export const textStyled = (family, weight, size, height, colorName, colorType, marbot = '') => `
	font-family: ${themeObject.font.fontFamily[family]};
	font-weight: ${themeObject.font.fontWeight[family][weight]};
	font-size: ${size};
	line-height: ${height};
	color: ${themeObject.colors[colorName][colorType]};
	${marbot && `margin-bottom: ${marbot};`}
`
export const textModels = (modelsName, modelsType, fontWeight = '') => `
font-family: ${themeObject.fontModels[modelsName][modelsType].family};
font-size: ${themeObject.fontModels[modelsName][modelsType].size};
line-height: ${themeObject.fontModels[modelsName][modelsType].lineHeight};
${
	themeObject.fontModels[modelsName][modelsType]?.weight && !fontWeight
		? `font-weight: ${themeObject.fontModels[modelsName][modelsType].weight};`
		: `font-weight: ${fontWeight};`
}
${
	(themeObject.fontModels[modelsName][modelsType]?.media ?? '') &&
	themeObject.fontModels[modelsName][modelsType].media
}
`
export const textModel = (modelsName, modelsType, colorName, colorType, marbot = '') => `
${textModels(modelsName, modelsType)}
	color: ${themeObject.colors[colorName][colorType]};
	${marbot && `margin-bottom: ${marbot};`}
`

export const Text = styled.span<{ color: string }>`
	${({ color }) =>
		css`
			color: #${color};
		`}
`
export const container = css`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	width: 100%;
	scroll-behavior: smooth;
	${media('align-items: center', Breakpoints.xl)}
`
export const Container = styled.div<{ isButton: boolean }>`
	${container};
	padding-top: ${({ isButton }) => (isButton ? '64px' : '56px')};
`
export const wrapper = (arg) => `
	${arg}: 0px 22px;
	${media(`${arg}: 0px 30px;`, Breakpoints.ms)}
	${media(`${arg}: 0px 72px;`, Breakpoints.lx)};
	${media(`${arg}: 0px 0px; width: 1216px;`, Breakpoints.xl)}
`
export const WrapperBlock = styled.div`
	width: 100%;
	box-sizing: border-box;
	${wrapper('padding')}
`
export const WrapperColor = styled(WrapperBlock)`
	display: flex;
	flex-direction: column;
	background: ${themeObject.colors.grey[50]};
	padding-top: 64px;
	padding-bottom: 64px;
	width: 100%;
	${media('padding-top: 88px; padding-bottom: 88px;', Breakpoints.lx)}
	${media('align-items: center;', Breakpoints.xl)}
`
export const Block = styled.div`
	display: flex;
	flex-direction: column;
	${media('flex-direction: row; width: 1216px;', Breakpoints.xl)}
`

export const Spacing = styled.div<{
	height: string
	heightMS?: string
	heightLX?: string
	heightXL?: string
}>`
	box-sizing: border-box;
	width: 100%;
	${({ height }) =>
		(height ?? '') &&
		css`
			height: ${height};
		`}
	${({ heightMS }) => (heightMS ?? '') && media(`height: ${heightMS};`, Breakpoints.ms)}
	${({ heightLX }) => (heightLX ?? '') && media(`height: ${heightLX};`, Breakpoints.lx)}
	${({ heightXL }) => (heightXL ?? '') && media(`height: ${heightXL};`, Breakpoints.xl)}
`

export const shadow = (key: string) => {
	const mode = `background: ${themeObject.colors.base.white}; border-radius: 8px;`
	switch (key) {
		case 'xs':
			return `${mode} box-shadow: 0px 1px 2px 0px rgba(34, 37, 57, 0.05);`
		case 's':
			return (
				`${mode} box-shadow: 0px 1px 2px 0px rgba(34, 37, 57, 0.06), ` +
				'0px 1px 3px 0px rgba(34, 37, 57, 0.1);'
			)
		case 'm':
			return (
				`${mode} box-shadow: 0px 2px 4px -2px rgba(34, 37, 57, 0.06), ` +
				'0px 4px 8px -2px rgba(34, 37, 57, 0.1);'
			)
		case 'l':
			return (
				`${mode} box-shadow: 0px 4px 6px -2px rgba(34, 37, 57, 0.03), ` +
				'0px 12px 16px -4px rgba(34, 37, 57, 0.08);'
			)
		case 'xl':
			return (
				`${mode} box-shadow: 0px 8px 8px -4px rgba(34, 37, 57, 0.03), ` +
				'0px 20px 24px -4px rgba(34, 37, 57, 0.08);'
			)
		case 'xxl':
			return `${mode} box-shadow: 0px 24px 48px -12px rgba(34, 37, 57, 0.18);`
		case 'xxxl':
			return `${mode} box-shadow: 0px 32px 64px -12px rgba(34, 37, 57, 0.14);`
		default:
			return ''
	}
}
export const grid = css<{ grid: string; gap: string; options: string; media: string }>`
	display: grid;
	grid: ${({ grid }) => (grid ?? '') && grid};
	row-gap: ${({ gap }) => (gap ?? '') && gap};
	${({ options }) => (options ?? '') && options};
	${({ media }) => (media ?? '') && media};
`
export const gridTwo = css`
	display: grid;
	grid: repeat(2, 1fr) / 1fr;
	row-gap: 32px;
	justify-content: space-between;
	${media('grid: 1fr / repeat(2, 1fr); column-gap: 48px;', Breakpoints.ms)};
	${media('column-gap: 80px;', Breakpoints.xl)};
`
export const gridThree = css`
	display: grid;
	grid: repeat(3, 1fr) / 1fr;
	row-gap: 32px;
	justify-content: space-between;
	${media('grid: 1fr / repeat(3, 1fr);', Breakpoints.ms)};
`
export const gridFour = css`
	display: grid;
	grid: auto auto auto auto / 1fr;
	row-gap: 24px;
	justify-content: space-between;
	${media('grid: repeat(2, 1fr) / repeat(2, 1fr); gap: 32px;', Breakpoints.ms)};
	${media('grid: 1fr / repeat(4, 1fr); row-gap: 0px;', Breakpoints.xl)};
`

export const Tab = styled.button<{ tabActive: boolean }>`
	padding: 12px 20px;
	border: 1px solid ${themeObject.colors.grey[200]};
	border-radius: 8px;
	color: ${themeObject.colors.grey[800]};
	background: ${themeObject.colors.base.white};
	${textModels('notAdaptive', 'm', '400')}
	flex-shrink: 0;
	margin-right: 12px;
	${({ tabActive }) =>
		tabActive &&
		css`
			background: ${themeObject.colors.grey[100]};
			font-weight: 600;
		`}
	&:last-child {
		margin-right: 0px;
	}
`

const buttonStyle = css`
	height: 44px;
	min-height: 44px;
	display: flex;
	justify-content: center;
	align-items: center;
	border: 0px;
	background: #21ba72;
	border-radius: 43px;
	${media('border-radius: 32px; font-weight: 600;', Breakpoints.ms)};
	${media('border-radius: 64px;', Breakpoints.xl)};
	&:disabled {
		background: #90dcb8;
		cursor: not-allowed;
	}
	&:active,
	&:hover,
	&:focus {
		background: #198c56;
	}
`
export const ButtonGeneral = styled.button`
	${buttonStyle}
`
